import { ApplicationController } from "../../application_controller"

export default class extends ApplicationController {
	initialize() {
		$(this.element).find('a[data-has-goto-url="true"]').on('click', function() {
			localStorage.setItem(`goto-for-${$(this).attr('href')}`, window.location.pathname)
		})
	}
}